export const messages = {
  defaultCancelChangesDialog: {
    title: 'Do you want to continue?',
    text: 'All your changes will be lost.',
    confirmButtonLabel: 'Yes, cancel',
    cancelButtonLabel: 'No',
  },
  defaultDangerActionConfirmationDialog: {
    text: 'It will remove your item.',
    confirmButtonLabel: 'Yes, delete it.',
  },
  defaultDialog: {
    title: 'Are you sure?',
    confirmButtonLabel: 'Confirm',
  },
  cancelButtonLabel: 'Cancel',
} as const
